import React from 'react';
import { useParams } from 'react-router-dom';
import { BigBagOrderDetails, DeliveryDetails, OwnDetails, OtherDetails } from './orders/_orders';
import { OrderType } from 'types';
import { NotFound } from '../../pages';

import '../../styles/pages/orders/orderDetails.scss';

const OrderDetails = () => {
	const { type = '0' } = useParams();

	switch (type) {
		case '0':
		case OrderType.classic:
			return <DeliveryDetails />;

		case '1':
		case OrderType.own:
			return <OwnDetails />;

		case '2':
		case OrderType.other:
			return <OtherDetails />;

		case '3':
		case OrderType.loose:
			return <BigBagOrderDetails />;
	}

	return <NotFound />;
};

export default OrderDetails;
